import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Utils from '../../utils/index';
import styles from './Popover.module.css';

const propTypes = {
  closePopoverFn: PropTypes.func.isRequired,
  inputToFocus: PropTypes.object.isRequired,
  popoverStyle: PropTypes.string,
};

function Popover({ ...props }) {
  function escFunction(event) {
    if (event.key.toLowerCase().indexOf('esc') === 0) {
      props.closePopoverFn(props.inputToFocus);
    }
  }

  const closePopoverButton = useRef(null);

  useEffect(() => {
    document.addEventListener('keyup', escFunction);
    closePopoverButton.current.focus();
    return function cleanup() {
      document.removeEventListener('keyup', escFunction);
    };
  }, [props.closePopoverFn, props.inputToFocus]);

  function closePopoverFnWithCallbackRef(event) {
    const setFocus = event.clientX === 0 && event.pageY === 0; // Kludge-y way to determine if event is click or keyboard invoked
    props.closePopoverFn(props.inputToFocus, setFocus); // Only place focus back on item if event was keyboard invoked
  }

  const classes = `${styles.popover} ${props.popoverStyle || ''}`;
  const browser = Utils.browserInfo();
  const ariaLabel = browser.name === 'Edge' ? `${props.children} ${props.ariaLabel}` : `${props.ariaLabel}`;
  const setRole = browser.name === 'Firefox' ? 'alert' : 'alertdialog';

  return (
    <div role={setRole} aria-describedby="alert-dialog-description" className={classes}>
      <p role="document" tabIndex="0" id="alert-dialog-description">
        {props.children}
      </p>
      <button
        ref={closePopoverButton}
        className={styles['close-box']}
        onClick={closePopoverFnWithCallbackRef}
        aria-label={ariaLabel}
        data-id="popover-close-button"
      >
        close
      </button>
    </div>
  );
}

Popover.propTypes = propTypes;

Popover.defaultProps = {
  ariaLabel: 'Close dialogue',
};

export default Popover;
